import React, { Suspense } from "react";
import { redirect, useLoaderData, useNavigate, useSubmit } from "react-router-dom";
import CenteredSpinner from "../../../components/centerVPspinner";
import { Box, Button, Container, Grid, IconButton, Modal, Paper, Typography, TextField } from "@mui/material";
import api from "../../../hooks/useApi";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PageTitle from "../../../components/PageTitle";
const EDITABLE_FIELDS = ['email', 'name', 'last_name', 'second_name', 'phone', 'birth_date', 'city_of_residence'];

export async function loader({ request, params }) {
    const user_id = params.user_id;
    const response = await api.get('/api/users/partners/');
    const user = (response.data?.users || []).find((item) => String(item.id) === String(user_id));
    if (!user) throw new Response('Користувача не знайдено', {status: 404});
    return {id: user_id, user: Object.fromEntries(EDITABLE_FIELDS.map((key) => [key, user[key] == null ? '' : key === 'birth_date' ? String(user[key]).slice(0, 10) : user[key]]))};
}
export async function action({ request, params }) {
    const formData = await request.formData();
    const id = params.user_id;
    const actionData = {};
    try {
        const payload = Object.fromEntries(EDITABLE_FIELDS.map((field) => [field, formData.get(field) || '']));
        await api.patch(`/api/users/partners/${id}/`, payload);
        return redirect('/all-users');
    }

    catch (e) {
        actionData.error = e
    }
    return actionData;
}

export default function EditUserDetails() {
    const loaderData = useLoaderData();
    const navigate = useNavigate();
    const submit = useSubmit();
    const [values, setValues] = React.useState(loaderData.user);
    React.useEffect(() => setValues(loaderData.user), [loaderData.id, loaderData.user]);

    return (

        <Modal
            open={true}
            onClose={() => navigate('/all-users')}
            className='flex abs-center'
        >
            <Suspense fallback={<CenteredSpinner />}>
                    {(() => {
                        const user = loaderData.user;
                        //console.log(promise.data)
                        return (
                            <>
                                <Container maxWidth='md'>
                                    <PageTitle title={`Редагування користувача: ${loaderData.id || "ID"}`} />
                                    <Paper style={{ padding: '20px', maxHeight: '90vh', overflow:'auto' }}>
                                        <Grid container spacing={2}>
                                            <Grid item container>
                                                <Box className='flex stickSides fullW'>
                                                    <Box className='flex flexCol'>
                                                        <Box>
                                                            <Typography color='blue' variant='body' className='flex abs-center'>
                                                                <EditOutlinedIcon style={{ marginRight: 5 }} />
                                                                Редагувати користувача
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ marginTop: 5 }}>
                                                            {user.last_name} {user.name}
                                                        </Box>
                                                    </Box>
                                                    <Box className='flex' alignItems='center'>
                                                        <IconButton
                                                            style={{ height: 'fit-content' }}
                                                            onClick={() => navigate('/all-users')}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item container spacing={2} component="form" method="post" onSubmit={(event) => { event.preventDefault(); submit(new FormData(event.currentTarget), {method: 'post'}); }} style={{ overflow: 'auto', maxHeight: '90%' }}>
                                                {EDITABLE_FIELDS.map((field) => <Grid item xs={12} sm={field === 'birth_date' ? 6 : 12} key={field}><TextField fullWidth name={field} label={field} type={field === 'birth_date' ? 'date' : 'text'} value={values[field]} onChange={(event) => setValues({...values, [field]: event.target.value})} InputLabelProps={field === 'birth_date' ? {shrink: true} : undefined}/></Grid>)}
                                                <Grid item xs={12}><Button type="submit" variant="contained">Зберегти</Button></Grid>
                                            </Grid>
                                            <Grid item container justifyContent="flex-end">
                                                <Button onClick={() => navigate('/all-users')}>Скасувати</Button>
                                            </Grid>
                                            {/* <Grid item container
                                                direction='row'
                                                justifyContent='space-between'
                                            >
                                                <Grid item xs>
                                                    <Button color='greyButtons' className='fullwh' variant='contained'>Скасувати</Button>
                                                </Grid>
                                                <Grid item xs={2}
                                                //empty space
                                                >

                                                </Grid>
                                                <Grid item xs>
                                                    <Button color='blueButtons' className='fullwh' variant='contained'>Зберегти</Button>
                                                </Grid>
                                            </Grid> */}
                                        </Grid>
                                    </Paper>
                                </Container>
                            </>
                        )
                    })()}
            </Suspense>
        </Modal>
    )
}

